import { useContext } from "react";
const populations: Record<string, number> = require("../data/populations.json");
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../context/ThemeContext";
import { getPath } from "../util/svg";
import { answerCountry } from "../util/answer";

type Props = {
  setReSpin: React.Dispatch<React.SetStateAction<boolean>>;
  setShowStats: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function Header({ setReSpin, setShowStats }: Props) {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  function reRenderGlobe() {
    setReSpin(true);
    navigate("/game");
  }

  const svgColour = theme.nightMode ? "rgb(209 213 219)" : "black";

  function handleHint() {
    const name = answerCountry?.properties?.NAME || "";
    if (!name) return;
    // Determine current hint level (0..2). We'll store in localStorage to persist per session.
    const current = parseInt(localStorage.getItem("hint_level") || "0");
    if (current >= 3) {
      window.alert("No more hints available for this round.");
      return;
    }
    const next = current + 1;
    let message = "";
    if (next === 1) {
      const pop = (populations as Record<string, number>)[name];
      message = `Population: ${pop ? pop.toLocaleString() : "Unknown"}`;
    } else if (next === 2) {
      const continent = answerCountry?.properties?.CONTINENT || "Unknown";
      message = `Continent: ${continent}`;
    } else if (next === 3) {
      const first = name.charAt(0).toUpperCase();
      message = `First letter: ${first}`;
    }
    if (window.confirm(`Show hint #${next}?`)) {
      window.alert(message);
      localStorage.setItem("hint_level", String(next));
    }
  }

  return (
    <header className="mt-8 h-10 relative dark:text-gray-200 z-10">
      <div className="relative h-full">
        <div className="space-x-2 flex absolute left-0 bottom-1">
          <button onClick={() => navigate("/")} aria-label="Help">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
              width="24"
            >
              <path fill={svgColour} d={getPath("help")}></path>
            </svg>
          </button>
          <button onClick={handleHint} aria-label="Hint" className="px-2 py-1 rounded-md bg-sky-100 dark:bg-slate-700">
            <span className="font-medium">hint</span>
          </button>
        </div>
        <button
          className="absolute bottom-0 left-1/2 transform -translate-x-1/2 "
          onClick={reRenderGlobe}
        >
            <h1
            className="text-4xl font-extrabold"
            style={{ fontFamily: "'Montserrat'" }}
          >
            Super Global
          </h1>
        </button>
        <div className="space-x-1 flex absolute right-0 bottom-1">
          <button onClick={() => setShowStats(true)} aria-label="Statistics">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
              width="24"
            >
              <path fill={svgColour} d={getPath("stats")}></path>
            </svg>
          </button>
          <button onClick={() => navigate("/settings")} aria-label="Settings">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
              width="24"
            >
              <path fill={svgColour} d={getPath("settings")}></path>
            </svg>
          </button>
        </div>
      </div>
      <hr className="bottom-0" style={{ borderColor: svgColour }} />
      {/* <SnackAdUnit unitName="snack_mob_top" siteId="2902"></SnackAdUnit> */}
    </header>
  );
}
